// src/components/Carousel.js
import React, { useState, useRef, useEffect } from "react";

const Carousel = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollerRef = useRef(null);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index, 10);
            setActiveIndex(index);
          }
        });
      },
      {
        root: scroller,
        threshold: 0.51,
      }
    );

    const childrenElements = Array.from(scroller.children).filter(
      (child) => child.tagName !== "SPAN" // Exclude our spacer pseudo-elements
    );

    childrenElements.forEach((el, index) => {
      el.dataset.index = index; // Assign index to each child
      observer.observe(el);
    });

    return () => childrenElements.forEach((el) => observer.unobserve(el));
  }, [children]);

  return (
    <div className="carousel-container">
      <div className="carousel-scroller" ref={scrollerRef}>
        {children}
      </div>
      <div className="carousel-pagination">
        {React.Children.map(children, (_, index) => (
          <div
            key={index}
            className={`dot ${index === activeIndex ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
